import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, HrefPill } from '../../components';
import { getIcon } from '../iconMap';

function ProspectusDeadlines({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const p = data.prospectus_card || {};
  const d = data.deadlines_card || {};
  const PI = getIcon(p.icon);
  const DI = getIcon(d.icon);
  const updateP = (patch) => update({ prospectus_card: { ...p, ...patch } });
  const updateD = (patch) => update({ deadlines_card: { ...d, ...patch } });
  const dItems = d.items || [];
  const updateDItem = (i, patch) => {
    const next = dItems.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    updateD({ items: next });
  };
  return (
    <section className="py-24 bg-olive-light">
      <div className="container-page grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="rounded-3xl p-10 bg-gradient-to-br from-olive-deep to-olive-footer text-white relative overflow-hidden h-full">
            <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-accent/20 blur-3xl" />
            <PI size={36} className="text-accent" />
            <EditableText value={p.title} onChange={(t) => updateP({ title: t })} as="h3" className="font-display text-3xl mt-4" />
            <EditableText value={p.body} onChange={(t) => updateP({ body: t })} as="p" multiline className="mt-3 text-white/80" />
            {p.cta && (
              <div className="mt-6 inline-flex flex-col">
                <Link to={p.cta.href || '#'} className="btn-accent inline-flex">
                  <EditableText value={p.cta.label} onChange={(t) => updateP({ cta: { ...(p.cta || {}), label: t } })} as="span" />
                  <ArrowRight size={16} />
                </Link>
                <HrefPill value={p.cta.href} onChange={(h) => updateP({ cta: { ...(p.cta || {}), href: h } })} />
              </div>
            )}
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="card-surface p-8 h-full">
            <h3 className="font-display text-2xl flex items-center gap-3"><DI className="text-olive" /> <EditableText value={d.title} onChange={(t) => updateD({ title: t })} as="span" /></h3>
            <div className="mt-6 grid grid-cols-3 gap-3">
              {dItems.map((c, i) => (
                <div key={i} className="rounded-2xl bg-olive-light p-4 text-center">
                  <EditableText value={c.date} onChange={(t) => updateDItem(i, { date: t })} as="div" className="font-display text-2xl text-olive-deep" />
                  <EditableText value={c.label} onChange={(t) => updateDItem(i, { label: t })} as="div" className="text-xs text-ink/60 mt-1" />
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default ProspectusDeadlines;
